import ManagementSectionManager, { type ManagerFieldDef, type ManagerColumnDef } from '@/components/ManagementSectionManager';
import { ServiceIconPreview } from '@/components/ServiceIconField';

const fields: ManagerFieldDef[] = [
  { name: 'title', label: 'Service Title', type: 'text', required: true, maxLength: 120, placeholder: 'Artist Management' },
  { name: 'description', label: 'Description', type: 'textarea', required: true, maxLength: 2000, placeholder: 'Describe what your company offers.' },
  { name: 'icon', label: 'Service Icon', type: 'serviceIcon' },
  {
    name: 'imageUrl',
    label: 'Card Image',
    type: 'image',
    aspectRatio: 16 / 9,
    helpText: 'Optional. Upload a PNG or JPEG (up to 2 MB) and crop to 16:9. Shown full-width above the icon and text on the website card.',
  },
];

const columns: ManagerColumnDef[] = [
  {
    name: 'title',
    label: 'Service',
    render: (item) => (
      <div className="flex items-center gap-3">
        <div className="size-10 shrink-0 flex items-center justify-center">
          <ServiceIconPreview value={item.icon} />
        </div>
        <span className="font-medium">{item.title}</span>
      </div>
    ),
  },
  {
    name: 'imageUrl',
    label: 'Card Image',
    render: (item) => item.imageUrl
      ? <img src={item.imageUrl} alt="" className="w-24 aspect-video rounded-md object-cover" />
      : <span className="text-sm text-muted-foreground">No image</span>,
  },
  { name: 'description', label: 'Description', render: (item) => <p className="line-clamp-2 max-w-md text-muted-foreground">{item.description}</p> },
];

export default function ServicesManager() {
  return (
    <ManagementSectionManager
      title="Services"
      description="Show what your company offers. Add as many services as you need."
      apiPath="/api/services"
      sectionKey="services"
      itemLabel="service"
      fields={fields}
      columns={columns}
      toggleField={{ name: 'isActive' }}
      emptyHint="Add your first service to display service cards on your management website."
    />
  );
}
